import classNames from "classnames";

interface CheckboxProps {
  className?: string;
  boxClassName?: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
}

export default function Checkbox({
  className = "",
  boxClassName = "",
  label,
  checked,
  onChange,
  ariaLabel,
}: CheckboxProps) {

  return (
    <div 
      className={classNames(
        "flex items-start space-x-3 xl:space-x-4 select-none",
        className
      )}
    >
      <label className="group relative flex items-center justify-center custom-cursor-hover cursor-pointer xl:cursor-none">
        <input 
          type="checkbox" 
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="peer sr-only"
          aria-label={ariaLabel}
        />
        
        {/* box */}
        <div className={classNames(boxClassName,
          "w-5 h-5 xl:w-6 xl:h-6 shrink-0 rounded-md border-2 transition-all duration-300 ease-out mt-0.75 md:mt-1 xl:mt-0.75",
          "bg-beige border-black dark:bg-black dark:border-white/50",
          "peer-checked:bg-green peer-checked:border-green dark:peer-checked:bg-green dark:peer-checked:border-green",
          "group-hover:scale-110 group-hover:border-green group-hover:shadow-[0_0_12px_rgba(var(--color-green,0,255,0),0.3)]"
        )} />
        
        {/* checkmark */}
        <svg 
          className={classNames(
            "absolute w-3 h-3 md:w-4 md:h-4 text-white pointer-events-none transition-all duration-300 ease-out mt-1",
            checked ? "scale-100 opacity-100" : "scale-50 opacity-0"
          )}
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="3.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </label>
      
      <span className="text-[16px] md:text-[18px] xl:text-[20px] font-medium text-black dark:text-white">
        {label}
      </span>
    </div>
  );
}